import React, { Component, Fragment, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { fromJS } from "immutable";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as Play } from "assets/icons/Play-Launch.svg";
import { ReactComponent as PlayDemo } from "assets/icons/play-demo.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { getTotalPool } from "utils/getTotalpool";
import { isEmpty } from "lodash";
import { currencyFormatter } from "utils/currencyHelper";
import { withNamespaces } from "react-i18next";
import { renderWithBoldHelper } from "utils/renderWithBoldHelper";

import * as queryString from "query-string";

import "containers/GameActionCollapse/styles.scss";

const ACTION_COLLPSE_MODAL = "ACTION_COLLPSE_MODAL";

class GameActionCollapse extends Component {
  constructor(props) {
    super(props);

    this.modalRef = createRef();
    this.modalActionRef = createRef();
    this.modalCollpaseContentRef = createRef();
    this.modalCollpaseRootRef = createRef();
    this.getTotalPool = getTotalPool.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.onExpandDetails = this._onExpandDetails.bind(this);
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.onClickEventHandler = this._onClickEventHandler.bind(this);
    this.getDetails = this._getDetails.bind(this);
    this.fetchGameUrl = this._fetchGameUrl.bind(this);
    this.handleScroll = this._handleScroll.bind(this);

    this.state = {
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      expand: false,
      hasPromotionIcons: null,
      showCategoryLabel: false,
      jackpotPool: null,
    };
  }

  _getDetails(gameId) {
    this.setState({
      isLoading: true,
      isLoadingRelated: true,
      loadingGameRel: null,
      details: null,
      relatedLinks: null,
      similarLink: null,
      launchRealLink: null,
      launchDemoLink: null,
      realUrl: null,
      demoUrl: null,
      realLink: null,
      demoLink: null,
      hasPromotionIcons: null,
      showCategoryLabel: false,
    });

    this.props
      .fetchGameDetailsUrl(gameId)
      .then((response) => {
        let link = fromJS(response);
        return this.props.fetchGameDetails(link);
      })
      .then((response) => {
        let details = fromJS(response.payload.data);
        let hasPromotionIcons =
          details.get("hasFreeRounds") ||
          details.get("partOfOnGoingTournament") ||
          details.get("isFeatured") ||
          details.get("isJackpot");
        this.setState({
          details,
          hasPromotionIcons,
        });
        return;
      })
      .then(() => {
        let realLink;
        try {
          realLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.real";
          });
        } catch (err) {}
        this.setState({
          realLink,
        });
      })
      .then(() => {
        let demoLink;
        try {
          demoLink = this.state.details.get("links").find((link) => {
            return link.get("rel") === "launch.demo";
          });
          this.setState({
            demoLink,
          });
        } catch (err) {
          return;
        }
      })
      .then(() => {
        this.setState({
          isLoading: false,
          isLoadingRelated: false,
        });
      });
  }

  async _onClickEventHandler(link) {
    let url;
    const newWindow = window.open("", this.props.gameLaunchTarget); // Open immediately

    this.setState({
      loadingGameRel: link.get("rel"),
    });

    await this.fetchGameUrl(link);

    switch (link.get("rel")) {
      case "launch.real":
        url = this.state.realUrl;
        break;
      case "launch.demo":
        url = this.state.demoUrl;
        break;
      default:
        url = null;
        break;
    }

    if (url) {
      newWindow.location.href = url;
    } else {
      newWindow.close();
    }

    this.setState({
      loadingGameRel: null,
    });
  }

  _fetchGameUrl(link) {
    let params;
    let returnUrl;
    switch (this.props.gameLaunchTarget) {
      case "_top":
      case "_parent":
      case "_self":
        let urlParams = new URLSearchParams(this.props.location.search);
        let redirectParams = new URLSearchParams();
        let url = `${this.props.location.pathname}?${urlParams.toString()}`;
        redirectParams.set("redirect", btoa(encodeURIComponent(url)));
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${
          this.props.match.params.sessionId
        }/exit?${redirectParams.toString()}`;
        break;
      default:
        returnUrl = `${window.location.origin}/${
          this.props.match.params.locale
        }/${this.props.match.params.sessionId}/exit`;
        break;
    }
    params = {
      returnUrl,
    };

    if (this.props.appId) {
      params = {
        returnUrl: `${this.props.appId}://lobby`,
      };
    }

    return this.props
      .fetchGameUrl(link, params)
      .then((response) => {
        if (link.get("rel") === "launch.real") {
          this.setState({
            launchRealLink: link,
            realUrl: response.payload.data.url,
          });
        } else if (link.get("rel") === "launch.demo") {
          this.setState({
            launchDemoLink: link,
            demoUrl: response.payload.data.url,
          });
        }
        return response;
      })
      .catch((err) => {
        this.setState({
          loadingGameRel: null,
        });
      });
  }

  _onGameItemClickHandler(game, rel) {
    this.setState({
      loadingGameRel: null,
    });
    let gameId = game.get("gameId");
    let nav = this.props.nav;
    this.props.gameClick(gameId, rel, nav).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
    this.props.clearGameAction();
  }

  _onExpandDetails() {
    this.setState({
      expand: !this.state.expand,
    });
  }

  _onCloseClickHandler() {
    this.setState({
      expand: false,
    });
    this.props.fetchBalance();
    let search = queryString.parse(this.props.location.search);
    delete search.gameId;
    delete search.playType;
    delete search.nav;
    this.props.navigateTo(`${this.props.location.pathname}`);
  }

  componentDidMount() {
    this.initObserver();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.gameAction !== nextProps.gameAction) {
      if (nextProps.gameAction === null) {
        this.props.hideModal(ACTION_COLLPSE_MODAL);
        this.setState({
          expand: false,
        });
      } else {
        this.setState({
          complete: false,
        });
        this.getDetails(nextProps.gameAction.get("gameId"));
        this.props.showModal(ACTION_COLLPSE_MODAL);
      }
    }
    if (
      nextProps.gameActionDetails &&
      this.props.gameActionDetails !== nextProps.gameActionDetails
    ) {
    }
    if (
      this.state.details &&
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.state.details.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  _handleScroll(event) {
    const { scrollTop } = event.currentTarget;
    if (scrollTop !== 0) {
      this.setState({ showCategoryLabel: true });
    } else {
      this.setState({ showCategoryLabel: false });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && this.props.gameAction) {
              let newLoc = `${
                this.props.location.pathname
              }?${queryString.stringify(this.props.gameAction.toJSON())}`;
              this.props.setGameActionDetails(this.state);
              this.props.navigateTo(newLoc);
              this.props.clearGameAction();
              this.setState({
                expand: false,
              });
            }
          });
        },
        {
          //root: this.modalCollpaseRootRef.current,
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.modalCollpaseContentRef.current);
    } else {
      this.getGames(this.props.link);
      this.getTournamentPreview(this.props.links);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div
        className={`game-action-collapse modal ${
          this.props.gameAction ? "show" : ""
        } ${this.state.expand ? "expand" : ""} ${
          this.state.complete ? "complete" : ""
        }`}
        onClick={() => {
          if (this.state.loadingGameRel) return;
          this.props.clearGameAction();
        }}
      >
        <div
          className="modal-dialog nopadding"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className="modal-content">
            <div
              className="modal-observer"
              ref={this.modalCollpaseContentRef}
            />
            <div
              className="modal-body"
              ref={this.modalActionRef}
              onScroll={this.handleScroll}
            >
              <div
                className="header-game-action"
                disabled={this.state.loadingGameRel !== null}
              >
                {!this.state.expand && !this.state.isLoading && (
                  <button
                    className="more"
                    onClick={this.onExpandDetails}
                    disabled={this.state.loadingGameRel !== null}
                  >
                    {t("more")}
                  </button>
                )}
                {!this.state.expand &&
                  (this.state.isLoading || this.state.isLoadingRelated) && (
                    <span className="more">
                      <span className="dummy">XXXX</span>
                    </span>
                  )}
                {this.state.expand && (
                  <PreviousIcon
                    onClick={this.props.history.goBack}
                    disabled={this.state.loadingGameRel !== null}
                  />
                )}
                {!this.state.expand &&
                  !this.state.isLoading &&
                  !this.state.isLoadingRelated && (
                    <button
                      className="horizontal-bar"
                      onClick={this.onExpandDetails}
                      disabled={this.state.loadingGameRel !== null}
                    >
                      &nbsp;
                    </button>
                  )}
                {!this.state.expand && (
                  <button
                    className="close-btn"
                    onClick={this.props.clearGameAction}
                    disabled={this.state.loadingGameRel !== null}
                  >
                    {t("close")}
                  </button>
                )}
                {this.state.details && this.state.expand && (
                  <span
                    className={`details-actions ${
                      this.state.showCategoryLabel ? "" : ""
                    }`}
                    ref={this.actionLabel}
                  >
                    {this.state.details.get("name")}
                  </span>
                )}
                {this.state.expand && (
                  <CloseIcon onClick={this.onCloseClickHandler} />
                )}
              </div>
              <div className="image-spacer" />
              <div className="row">
                <div className="col">
                  <div className="info">
                    <div className="title">
                      {!this.state.details && (
                        <span className="dummy">XXXX XXXXXX</span>
                      )}

                      {this.state.details && this.state.details.get("name") && (
                        <Fragment>
                          {this.state.hasPromotionIcons && (
                            <span className="game-feature">
                              {this.state.details.get(
                                "partOfOnGoingTournament"
                              ) && (
                                <span className="game-feature-badge trophyIcon">
                                  <TrophyIcon color="rgba(255, 204, 0, 1)" />
                                </span>
                              )}
                            </span>
                          )}
                          <span>{this.state.details.get("name")}</span>
                        </Fragment>
                      )}
                    </div>
                    <div className="provider">
                      {!this.state.details && (
                        <span className="dummy">XXXXXXXX</span>
                      )}
                      {this.state.details &&
                        this.state.details.get("provider") && (
                          <span>{this.state.details.get("provider")}</span>
                        )}
                    </div>
                    <div className="provider jackpot-pool">
                      {!this.state.details && (
                        <span className="dummy">XXXXXXXX</span>
                      )}
                      {this.state.details &&
                        this.state.details.get("isJackpot") && (
                          <span className="game-feature-badge jackpotIcon">
                            <CrownIcon color="rgba(255, 204, 0, 1)" />
                            {renderWithBoldHelper(
                              t,
                              "totalJackpotPoolOf",
                              "amount",
                              this.getTotalPool(
                                this.state.jackpotPool,
                                this.state.details,
                                false
                              )
                            )}
                          </span>
                        )}
                      {this.state.details &&
                        this.state.details.get("totalFreePlayAmount") && (
                          <span className="game-feature-badge ribbonIcon">
                            <RibbonIcon color="rgba(255, 204, 0, 1)" />
                            {renderWithBoldHelper(
                              t,
                              "enjoyInFreePlay",
                              "amount",
                              currencyFormatter(
                                this.state.details.get("totalFreePlayAmount"),
                                { currency: this.props.currency }
                              )
                            )}
                          </span>
                        )}
                      {this.state.details &&
                        this.state.details.get("isFeatured") && (
                          <span className="game-feature-badge editorsChoiceIcon">
                            <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                            {t("editorsChoice")}
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {this.props.realLink && (
                    <button
                      className={`btn btn-danger w-100 ${
                        this.state.loadingGameRel === "launch.real"
                          ? "animate"
                          : ""
                      }`}
                      onClick={() => {
                        this.setState({
                          loadingGameRel: this.props.realLink.get("rel"),
                        });
                        switch (this.props.gameLaunchTarget) {
                          case "_top":
                          case "_self":
                          case "_parent":
                            let game = this.state.details;
                            let rel = this.props.realLink.get("rel");
                            this.onGameItemClickHandler(game, rel);
                            break;
                          default:
                            this.onClickEventHandler(this.state.realLink);
                            break;
                        }
                      }}
                      disabled={this.state.loadingGameRel !== null}
                    >
                      <span className="play-now-icon">
                        <Play />
                      </span>
                      &nbsp;
                      {t("playNow")}
                    </button>
                  )}
                  {!this.props.realLink &&
                    !this.props.demoLink &&
                    this.state.isLoading && (
                      <div className="btn btn-secondary w-100 dummy">
                        &nbsp;
                      </div>
                    )}
                  {!this.props.realLink &&
                    !this.state.isLoading &&
                    this.state.details &&
                    this.state.realLink && (
                      <button
                        className={`btn btn-danger w-100 ${
                          this.state.loadingGameRel === "launch.real"
                            ? "animate"
                            : ""
                        }`}
                        onClick={() => {
                          this.setState({
                            loadingGameRel: this.state.realLink.get("rel"),
                          });
                          switch (this.props.gameLaunchTarget) {
                            case "_top":
                            case "_self":
                            case "_parent":
                              let game = this.state.details;
                              let rel = this.state.realLink.get("rel");
                              this.onGameItemClickHandler(game, rel);
                              break;
                            default:
                              this.onClickEventHandler(this.state.realLink);
                              break;
                          }
                        }}
                        disabled={this.state.loadingGameRel !== null}
                      >
                        <span className="play-now-icon">
                          <Play />
                        </span>
                        &nbsp;
                        {t("playNow")}
                      </button>
                    )}

                  {!this.props.demoLink &&
                    !this.props.realLink &&
                    this.state.isLoading && (
                      <div className="btn btn-secondary w-100 dummy">
                        &nbsp;
                      </div>
                    )}

                  {!this.props.demoLink &&
                    !this.state.isLoading &&
                    this.state.details &&
                    this.state.demoLink && (
                      <button
                        className={`d-none btn btn-secondary w-100 ${
                          this.state.loadingGameRel === "launch.demo"
                            ? "animate"
                            : ""
                        }`}
                        onClick={() => {
                          this.setState({
                            loadingGameRel: this.state.demoLink.get("rel"),
                          });
                          switch (this.props.gameLaunchTarget) {
                            case "_top":
                            case "_self":
                            case "_parent":
                              let game = this.state.details;
                              let rel = this.state.demoLink.get("rel");
                              this.onGameItemClickHandler(game, rel);
                              break;
                            default:
                              this.onClickEventHandler(this.state.demoLink);
                              break;
                          }
                        }}
                        disabled={this.state.loadingGameRel !== null}
                      >
                        <span className="play-now-icon">
                          <PlayDemo />
                        </span>
                        &nbsp;{t("demoPlay")}
                      </button>
                    )}
                  {this.props.demoLink && (
                    <button
                      className={`btn btn-secondary w-100 ${
                        this.state.loadingGameRel === "launch.demo"
                          ? "animate"
                          : ""
                      }`}
                      onClick={() => {
                        this.setState({
                          loadingGameRel: this.props.demoLink.get("rel"),
                        });
                        switch (this.props.gameLaunchTarget) {
                          case "_top":
                          case "_self":
                          case "_parent":
                            let game = this.state.details;
                            let rel = this.props.demoLink.get("rel");
                            this.onGameItemClickHandler(game, rel);
                            break;
                          default:
                            this.onClickEventHandler(this.props.demoLink);
                            break;
                        }
                      }}
                      disabled={this.state.loadingGameRel !== null}
                    >
                      <span className="play-now-icon">
                        <PlayDemo />
                      </span>
                      &nbsp;{t("demoPlay")}
                    </button>
                  )}
                  {!this.state.isLoading &&
                    this.state.details &&
                    !this.state.realLink &&
                    !this.state.demoLink && (
                      <div className="no-gameplay">
                        {t("noAvailableGameplay")}
                      </div>
                    )}
                </div>
              </div>

              <table className={`tinfo`}>
                <tbody>
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("type")}: </th>
                      <td>
                        <span className="dummy">XXXXXX XX XXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("gameType") && (
                    <tr className="trinfo">
                      <th>{t("type")}: </th>
                      <td>{this.state.details.get("gameType")}</td>
                    </tr>
                  )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("features")}: </th>
                      <td>
                        <span className="dummy">XXX XX XXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details &&
                    this.state.details.get("specialFeatures") && (
                      <tr className="trinfo">
                        <th>{t("features")}: </th>
                        <td>
                          <span>
                            {this.state.details
                              .get("specialFeatures")
                              .join(", ")}
                          </span>
                        </td>
                      </tr>
                    )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("themes")}: </th>
                      <td>
                        <span className="dummy">XXXX XXX XXXXXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("themes") && (
                    <tr className="trinfo">
                      <th>{t("themes")}: </th>
                      <td>
                        <span>
                          {this.state.details.get("themes").join(", ")}
                        </span>
                      </td>
                    </tr>
                  )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("variance")}: </th>
                      <td>
                        <span className="dummy">XXX XX XXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("volatility") && (
                    <tr className="trinfo">
                      <th>{t("variance")}: </th>
                      <td>
                        <span>{this.state.details.get("volatility")}</span>
                      </td>
                    </tr>
                  )}
                  {!this.state.details && (
                    <tr className="trinfo">
                      <th>{t("releaseDate")}: </th>
                      <td>
                        <span className="dummy">XXX XX XXXXX</span>
                      </td>
                    </tr>
                  )}
                  {this.state.details && this.state.details.get("releaseDate") && (
                    <tr className="trinfo">
                      <th>{t("released")}: </th>
                      <td>
                        <span>{this.state.details.get("releaseDate")}</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let params;
  let gameId;
  let nav;
  let playType;
  let gameLaunchTarget;
  let currency = null;
  let latestBroadcast;
  let realLink;
  let demoLink;
  let game;

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  try {
    params = state.game.get("params");
  } catch (err) {}

  try {
    game = params.get("game");
  } catch (err) {}

  try {
    realLink = game.getIn(["links"]).find((link) => {
      return link.get("rel") === "launch.real";
    });
  } catch (err) {}

  try {
    demoLink = game.getIn(["links"]).find((link) => {
      return link.get("rel") === "launch.demo";
    });
  } catch (err) {}

  try {
    nav = params.get("nav");
  } catch (err) {}

  try {
    playType = params.get("playType");
  } catch (err) {}

  try {
    gameId = params.get("gameId");
  } catch (err) {}

  try {
    gameLaunchTarget = state.links.get("gameLaunchTarget");
  } catch (err) {}

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  return {
    playType,
    gameLaunchTarget,
    nav,
    realLink,
    demoLink,
    gameId,
    gameAction: state.game.get("params"),
    gameActionDetails: state.game.get("stateDetails"),
    isMobile: state.window.get("isMobile"),
    currency: currency,
    latestBroadcast,
    locale: state.config.getIn(["locale"]),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchGameDetailsUrl: (gameId) => dispatchProps.fetchGameDetailsUrl(gameId),
    fetchGameDetails: (link, params) =>
      dispatchProps.fetchGameDetails(link, params),
    fetchGameUrl: (link, params) => dispatchProps.fetchGameUrl(link, params),
    fetchRelatedLinks: (route, params) =>
      dispatchProps.fetchRelatedLinks(route, params),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    navigateTo: (path) => ownProps.history.push(`${path}`),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    fetchBalance: () => dispatchProps.fetchBalance(),
    clearGameAction: () => dispatchProps.clearGameAction(),
    setGameActionDetails: (payload) =>
      dispatchProps.setGameActionDetails(payload),
    onGameLaunch: (params) => dispatchProps.onGameLaunch(params),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withNamespaces("translation")(GameActionCollapse));
